module.exports = __webpack_public_path__ + "static/GloberRegular-672071dc48f786b67c19bcc6265302ed.woff";